import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaEye, FaRegFileExcel } from 'react-icons/fa6';
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import Loading from '../../components/Loading';
import AddAgence from './AddAgence';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';
import { FaEdit } from 'react-icons/fa';
import NumberFormat from '../../components/NumberFormat';
import EditAgence from './EditAgence';


const Agences = () => {
    const [errors, setErrors] = useState(null);

    const [loading, setLoading] = useState(false);
    const [agences, setAgences] = useState([]);
    const [showAddAgence, setShowAddAgence] = useState(false);
    const [showEditAgence, setShowEditAgence] = useState(false);
    const [selectedAgence, setSelectedAgence] = useState(null);
    const { token, setToken, user } = useStateContext();
    const tableRef = useRef();
    const [req, setReq] = useState({
        DateDebut: '',
        DateFin: '',
        exp: '',
    });
    const navigate = useNavigate();

    const supprimer = (agence) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/agence/' + agence.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getAgences();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

    useEffect(() => {
        getAgences();
    }, [])


    const closeAddAgence = () => {
        setShowAddAgence(false);
        
    }
    const closeEditAgence = () => {
        setShowEditAgence(false);
        setSelectedAgence(null);
    }
    const getAgences = () => {
        setLoading(true);
        axiosClient.get('/agences')
            .then(response => {
                setAgences(response.data.agences);
                setLoading(false);
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }


    return (
        <>
            <Header title="Agences" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            
            {
                user.role && user.role.name === 'admin' ? <div className="flex my-4">
                    <Button onClick={() => setShowAddAgence(true)} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                </div>
                    : <></>
            }
            <div className="flex my-2">
                <h1 className='text-red-500 font-bold'>Total solde: <NumberFormat valeur={agences.reduce((n, { solde }) => n + parseFloat(solde), 0)}/> MRU</h1>
            </div>
            <div className='flex mt-3 overflow-auto'>
                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th>code</th>
                            <th>Nom Agence </th>
                            <th>Zone</th>
                            <th>Adresse</th>
                            <th>Ville</th>
                            <th>Tel</th>
                            <th>Solde</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="8"><Loading /></td></tr></tbody> :
                        <tbody>
                            {agences.map(o => (
                                <tr>
                                    <td>{o.code}</td>
                                    <td>{o.nom}</td>
                                    <td>{o.zone.nom}</td>
                                    <td>{o.adresse}</td>
                                    <td>{o.ville}</td>
                                    <td>{o.tel}</td>
                                    <td>{o.solde}</td>
                                    <td>
                                        <div className="flex justify-center w-full items-center gap-2">
                                            <ActionButton onClick={() => { }} color="bg-green-500" icon={<FaEye />} textColor="text-white" title="Voir" />
                                            <ActionButton onClick={() => {
                                                setSelectedAgence(o);
                                                setShowEditAgence(true);
                                            }} color="bg-blue-500" icon={<FaEdit />} textColor="text-white" title="Modifier" />
                                            <ActionButton onClick={() => supprimer(o)} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Annuler" />
                                        </div>
                                    </td>
                                </tr>
                            ))

                            }
                        </tbody>
                    }

                </table>
            </div>
            {
                showAddAgence ? <AddAgence onClose={closeAddAgence} /> : <></>
            }
            {
                showEditAgence ? <EditAgence editedAgence={selectedAgence} onClose={closeEditAgence}/>:<></>
            }

        </>
    )
}

export default Agences